import { useQuery } from "@tanstack/react-query";
import { fetchPermissions } from "src/utils/Permissions/api";
import { IPermission } from "./permissions.models";

export const useFetchPermissions = () =>
  useQuery<IPermission[], Error>({
    queryKey: ["permissions"],
    queryFn: async ({ signal }) => fetchPermissions({ signal }),
  });
